import { graphql, useMutation } from "react-relay";

import type { useReviewToolUseMutationReviewToolUseMutation } from "./__generated__/useReviewToolUseMutationReviewToolUseMutation.graphql";

const mutation = graphql`
  mutation useReviewToolUseMutationReviewToolUseMutation(
    $input: ReviewToolUseInput!
  ) {
    reviewToolUse(input: $input) {
      success
    }
  }
`;

export const useReviewToolUseMutation = () => {
  const [commit, isInFlight] =
    useMutation<useReviewToolUseMutationReviewToolUseMutation>(mutation);

  const reviewToolUse = (
    toolUseId: string,
    status: "APPROVED" | "REJECTED",
    conversationId?: string,
    llmConversationId?: string,
    llmInteractionId?: string
  ) => {
    return new Promise<boolean>((resolve, reject) => {
      commit({
        variables: {
          input: {
            toolUseId,
            status,
            conversationId,
            llmConversationId,
            llmInteractionId,
          },
        },
        onCompleted: (response) => {
          resolve(response.reviewToolUse.success);
        },
        onError: (error) => {
          console.error("Failed to review tool use:", error);
          reject(error);
        },
      });
    });
  };

  return { reviewToolUse, isInFlight };
};
